import React, { useEffect, useState } from 'react';

import "./styles.css"

interface MultiDropdownProps {
    options: string[];
    selectedOptions: string[];
    onChange?: (selectedValues: string[]) => void;
    disabled?: boolean;
}
const MultiDropdown: React.FC<MultiDropdownProps> = ({ options, onChange, selectedOptions, disabled }) => {

    useEffect(() => {
        setSelectedValues(selectedOptions || []);
        setIsOpen(false);
    }, [selectedOptions])

    const [selectedValues, setSelectedValues] = useState(selectedOptions ?? [] as string[]);
    const [isOpen, setIsOpen] = useState(false);

    const toggleSelect = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };

    const handleSelectChange = (event: any) => {
        var selectedValue = event.target.value;
        let newSelectedValues = [...selectedValues, selectedValue];
        setSelectedValues(newSelectedValues);
        onValuesChange(newSelectedValues);
    };

    const removeOption = (option: string) => {
        let newSelectedValues = [...selectedValues].filter(s => s !== option);
        setSelectedValues(newSelectedValues);
        onValuesChange(newSelectedValues);
    }

    const removeAllSelectedOptions = () => {
        setSelectedValues([]);
        onValuesChange([]);
    }

    const onValuesChange = (values: string[]) => {
        if (onChange) {
            onChange(values);
        }
    }

    return (
        <>
            <div onClick={toggleSelect} className={`${isOpen ? 'open' : ''} form-control selected-options-container multi-selected-options-container`} aria-readonly={disabled} >
                {selectedValues.map((value) => (
                    <div key={value} className="form-control selected-section">
                        {value}
                        <span onClick={() => removeOption(value)} className="m-l-5 glyphicon glyphicon-remove"></span>
                    </div>
                ))}

                {selectedOptions?.length > 0 && < span onClick={() => removeAllSelectedOptions()} className="glyphicon glyphicon-remove delete-all-subsections-button"></span>}
            </div>

            {isOpen &&
                <select multiple value={selectedValues} onChange={handleSelectChange} className="form-control dropdown-container">
                    {options.filter(o => !selectedValues.some(s => o === s)).map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            }
        </>
    );
};


export default MultiDropdown;